import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import {UploadFile} from '@/vue-dlb/models'
import appUtil from '@/vue-dlb/utils/app-util'
import config from '@/vue-caas/config/config.js';

import {  
  commitRetDataSets
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";

const isDlbMybatis = config.isDlbMybatis;

const state = {
  mainGrid: [],
  custList: [],
  mainGridWindow: [],
  mapList: [],
  layoutPopopParam: [],
  dataSet01Source: [],
  dataSet02Source: [],
  filter: {},
  matchedMapWindowParam: {},
  mapSortList: [],
  mapFilterList: []
};

const getters = {
};

const actions = {
  queryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mainGrid");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MATCH_LIST_PRCS_MST_ALL_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {      
      commitRetDataSets(commit, res.data);
    });
  },
  getCustomerList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("custList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getCustomerList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MATCH_LIST_REPO_SRM_MST_FN";
    const reqdata = selectDataSetByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);    
    });

  },
  addSRMList: async ({ commit }, paramItems) => {    
    const retSet = new ObjDataSet("retSet");    
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("addSRMList");        
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "RepositoryManager";
    trSet.tranMethod = "copyFromRepositoryToCustomer";        
    const reqdata = callByDataSet(trSet);     
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
   });  
  },
  getMatchedMapList: async ({ commit }, searchItems) => {    
    const retSet = new ObjDataSet("mapList");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("getMatchedMapList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    trSet.tranID = "EDP_MATCH_LIST_MAP_MST_ALL_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);    
    });

  },
  saveSelectedMap: async ({ commit }, paramItems) => {    
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveSelectedMap");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "RepositoryManager";
      trSet.tranMethod = "saveSelectedMap";
      reqdata = callByDataSet(trSet);    
    } else {
      trSet.tranID = "EDP_MATCH_UPD_LAYOUT_MST_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet); 
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });

  },
  statusRollBack: async ({ commit }, paramItems) => {    
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("statusRollBack");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "RepositoryManager";
      trSet.tranMethod = "statusRollBack";
      reqdata = callByDataSet(trSet);    
    } else {
      trSet.tranID = "EDP_MATCH_UPD_PRCS_MST_DOCU_ROLLBACK_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet); 
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },  
  deleteMatchingProcData: async ({ commit }, paramItems) => {    
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteMatchingProcData");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "DataAnalysisManager";
    trSet.tranMethod = "deleteMatchingProcData";
    const reqdata = callByDataSet(trSet);    
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
};

const mutations = {
  mainGrid (state, datarows) {
    state.mainGrid = datarows;
    state.dataSet01Source = state.mainGrid;

    state.mainGridWindow = [];
    for (let i =0; i < datarows.length; i++) {
      let  dupTag = true
      if (i === 0) {
        state.mainGridWindow.push({
          LAY_PRCS_NO :  datarows[i].LAY_PRCS_NO,
          data: []
        });
        state.mainGridWindow[0].data.push({
          MST_MSG_STD: `${datarows[i].MST_MSG_STD}`,
          MST_MSG_VER: `${datarows[i].MST_MSG_VER}`,
          MPD_FILE_NAME: `${datarows[i].MPD_FILE_NAME}`,
          SYSSTATUS: `${datarows[i].SYSSTATUS}`,
          MST_MSG_SNDR: `${datarows[i].MST_MSG_SNDR}`,
          MST_MSG_RCVR: `${datarows[i].MST_MSG_RCVR}`,
          LAY_UPLD_DT: `${datarows[i].LAY_UPLD_DT}`,
          FFL_FILE_NAME: `${datarows[i].FFL_FILE_NAME}`,
          MAP_PRCS_NO: `${datarows[i].MAP_PRCS_NO}`,
          MST_PRCS_STS: `${datarows[i].MST_PRCS_STS}`,
          MAX_RATIO: `${datarows[i].MAX_RATIO}`,
          MST_MSG_ID: `${datarows[i].MST_MSG_ID}`,
          MST_UPD_DT: `${datarows[i].MST_UPD_DT}`,
          MAP_NAME: `${datarows[i].MAP_NAME}`,
          MSG_CNT: `${datarows[i].MSG_CNT}`,
          LAY_PRCS_NO: `${datarows[i].LAY_PRCS_NO}`,
          ROWID: `${datarows[i].ROWID}`
        })
      } else {
        for (let j =0 ; j < state.mainGridWindow.length; j++) {
          if ( state.mainGridWindow[j].LAY_PRCS_NO === datarows[i].LAY_PRCS_NO ) {
            state.mainGridWindow[j].data.push({
              MST_MSG_STD: `${datarows[i].MST_MSG_STD}`,
              MST_MSG_VER: `${datarows[i].MST_MSG_VER}`,
              MPD_FILE_NAME: `${datarows[i].MPD_FILE_NAME}`,
              SYSSTATUS: `${datarows[i].SYSSTATUS}`,
              MST_MSG_SNDR: `${datarows[i].MST_MSG_SNDR}`,
              MST_MSG_RCVR: `${datarows[i].MST_MSG_RCVR}`,
              LAY_UPLD_DT: `${datarows[i].LAY_UPLD_DT}`,
              FFL_FILE_NAME: `${datarows[i].FFL_FILE_NAME}`,
              MAP_PRCS_NO: `${datarows[i].MAP_PRCS_NO}`,
              MST_PRCS_STS: `${datarows[i].MST_PRCS_STS}`,
              MAX_RATIO: `${datarows[i].MAX_RATIO}`,
              MST_MSG_ID: `${datarows[i].MST_MSG_ID}`,
              MST_UPD_DT: `${datarows[i].MST_UPD_DT}`,
              MAP_NAME: `${datarows[i].MAP_NAME}`,
              MSG_CNT: `${datarows[i].MSG_CNT}`,
              LAY_PRCS_NO: `${datarows[i].LAY_PRCS_NO}`,
              ROWID: `${datarows[i].ROWID}`
            });
            dupTag = false;
            break;
          }
        }

        if (dupTag === true) {
          state.mainGridWindow.push({
            LAY_PRCS_NO :  datarows[i].LAY_PRCS_NO,
            data: []
          });
          state.mainGridWindow[state.mainGridWindow.length - 1].data.push({
            MST_MSG_STD: `${datarows[i].MST_MSG_STD}`,
            MST_MSG_VER: `${datarows[i].MST_MSG_VER}`,
            MPD_FILE_NAME: `${datarows[i].MPD_FILE_NAME}`,
            SYSSTATUS: `${datarows[i].SYSSTATUS}`,
            MST_MSG_SNDR: `${datarows[i].MST_MSG_SNDR}`,
            MST_MSG_RCVR: `${datarows[i].MST_MSG_RCVR}`,
            LAY_UPLD_DT: `${datarows[i].LAY_UPLD_DT}`,
            FFL_FILE_NAME: `${datarows[i].FFL_FILE_NAME}`,
            MAP_PRCS_NO: `${datarows[i].MAP_PRCS_NO}`,
            MST_PRCS_STS: `${datarows[i].MST_PRCS_STS}`,
            MAX_RATIO: `${datarows[i].MAX_RATIO}`,
            MST_MSG_ID: `${datarows[i].MST_MSG_ID}`,
            MST_UPD_DT: `${datarows[i].MST_UPD_DT}`,
            MAP_NAME: `${datarows[i].MAP_NAME}`,
            MSG_CNT: `${datarows[i].MSG_CNT}`,
            LAY_PRCS_NO: `${datarows[i].LAY_PRCS_NO}`,
            ROWID: `${datarows[i].ROWID}`
          })
        }
      }
    }

    state.mainGrid = state.mainGridWindow;

  },
  custList (state, datarows) {
    state.custList = datarows;
  },
  mapList (state, datarows) {
    datarows.sort((a,b) => ( parseFloat(a.RST_RATIO) <  parseFloat(b.RST_RATIO)) ? 1 : (( parseFloat(b.RST_RATIO) <  parseFloat(a.RST_RATIO)) ? -1 : 0));
    state.mapList = datarows;
    state.dataSet02Source = datarows;
  },
  sortMapList (state, colSort) {
    let datarows = state.dataSet01Source;
    
    if (state.filter && state.filter.str !== '') {
      let temp = [];
      for (let i=0; i < state.mainGrid.length; i++) {
        temp.push(state.mainGrid[i].data[0]);
      }
      state.mapFilterList = temp;
      datarows = [...state.mapFilterList];
    }
    let {col, sort} = colSort;
    state.sort = {
      type: sort
    };
    if (sort === 'reset') {
      state.mapList = [...state.dataSet01Source];
      state.mapSortList = [...state.dataSet01Source];
      if (state.filter && state.filter.str !== '') {
        state.mapList = [...state.mapFilterList];
        state.mapSortList = [...state.mapFilterList];
      }
      return;
    }

    datarows.sort((a ,b) => {
      return compareSort(a[col], b[col], sort);
    });

    state.mapList = [...datarows];
    state.mapSortList = [...datarows];
  },
  'RESET_FILTER_AND_SORT' (state) {
    if (state.sort) {
      state.sort.type = 'reset';
    }
    if (state.filter) {
      state.filter.str = '';
    }
  },
  'SET_LAYOUT_POPUP_PARAM' (state, layout) {
    state.layoutPopopParam = layout;
  },
  'SET_MATCHED_MAP_POPUP_PARAM' (state, layout) {
    state.matchedMapWindowParam = layout;
  },
  'SET_STORE_MAPLIST_FILTER' (state, filter) {
    let datarows = state.dataSet02Source;
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    if (filterBy != null) {

      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item =>  {

        for (const prop in item) {
          if (typeof item[prop] == 'string') {
            let propValue = item[prop].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[prop] == 'number') {
            let propValue = item[prop].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.mapList = listResult;
  },
  'SET_STORE_MATCHING_FILTER' (state, filter) {
    let datarows = state.dataSet01Source;
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    let sublistResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item => {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let
               queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item.data[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }

    //state.mainGrid = listResult;

    for (let i =0; i < listResult.length; i++) {
      let  dupTag = true
      if (i === 0) {
        sublistResult.push({
          LAY_PRCS_NO :  listResult[i].LAY_PRCS_NO,
          data: []
        });
        sublistResult[0].data.push({
          MST_MSG_STD: `${listResult[i].MST_MSG_STD}`,
          MST_MSG_VER: `${listResult[i].MST_MSG_VER}`,
          MPD_FILE_NAME: `${listResult[i].MPD_FILE_NAME}`,
          SYSSTATUS: `${listResult[i].SYSSTATUS}`,
          MST_MSG_SNDR: `${listResult[i].MST_MSG_SNDR ? listResult[i].MST_MSG_SNDR : '' }`,
          MST_MSG_RCVR: `${listResult[i].MST_MSG_RCVR ? listResult[i].MST_MSG_RCVR : '' }`,
          LAY_UPLD_DT: `${listResult[i].LAY_UPLD_DT}`,
          FFL_FILE_NAME: `${listResult[i].FFL_FILE_NAME}`,
          MAP_PRCS_NO: `${listResult[i].MAP_PRCS_NO}`,
          MST_PRCS_STS: `${listResult[i].MST_PRCS_STS}`,
          MAX_RATIO: `${listResult[i].MAX_RATIO}`,
          MST_MSG_ID: `${listResult[i].MST_MSG_ID}`,
          MST_UPD_DT: `${listResult[i].MST_UPD_DT}`,
          MAP_NAME: `${listResult[i].MAP_NAME}`,
          MSG_CNT: `${listResult[i].MSG_CNT}`,
          LAY_PRCS_NO: `${listResult[i].LAY_PRCS_NO}`,
          ROWID: `${listResult[i].ROWID}`
        })
      } else {
        for (let j =0 ; j < sublistResult.length; j++) {
          if ( sublistResult[j].LAY_PRCS_NO === listResult[i].LAY_PRCS_NO ) {
            sublistResult[j].data.push({
              MST_MSG_STD: `${listResult[i].MST_MSG_STD}`,
              MST_MSG_VER: `${listResult[i].MST_MSG_VER}`,
              MPD_FILE_NAME: `${listResult[i].MPD_FILE_NAME}`,
              SYSSTATUS: `${listResult[i].SYSSTATUS}`,
              MST_MSG_SNDR: `${listResult[i].MST_MSG_SNDR ? listResult[i].MST_MSG_SNDR : '' }`,
              MST_MSG_RCVR: `${listResult[i].MST_MSG_RCVR ? listResult[i].MST_MSG_RCVR : '' }`,
              LAY_UPLD_DT: `${listResult[i].LAY_UPLD_DT}`,
              FFL_FILE_NAME: `${listResult[i].FFL_FILE_NAME}`,
              MAP_PRCS_NO: `${listResult[i].MAP_PRCS_NO}`,
              MST_PRCS_STS: `${listResult[i].MST_PRCS_STS}`,
              MAX_RATIO: `${listResult[i].MAX_RATIO}`,
              MST_MSG_ID: `${listResult[i].MST_MSG_ID}`,
              MST_UPD_DT: `${listResult[i].MST_UPD_DT}`,
              MAP_NAME: `${listResult[i].MAP_NAME}`,
              MSG_CNT: `${listResult[i].MSG_CNT}`,
              LAY_PRCS_NO: `${listResult[i].LAY_PRCS_NO}`,
              ROWID: `${listResult[i].ROWID}`
            });
            dupTag = false;
            break;
          }
        }

        if (dupTag === true) {
          sublistResult.push({
            LAY_PRCS_NO :  listResult[i].LAY_PRCS_NO,
            data: []
          });
          sublistResult[sublistResult.length - 1].data.push({
            MST_MSG_STD: `${listResult[i].MST_MSG_STD}`,
            MST_MSG_VER: `${listResult[i].MST_MSG_VER}`,
            MPD_FILE_NAME: `${listResult[i].MPD_FILE_NAME}`,
            SYSSTATUS: `${listResult[i].SYSSTATUS}`,
            MST_MSG_SNDR: `${listResult[i].MST_MSG_SNDR ? listResult[i].MST_MSG_SNDR : '' }`,
            MST_MSG_RCVR: `${listResult[i].MST_MSG_RCVR ? listResult[i].MST_MSG_RCVR : '' }`,
            LAY_UPLD_DT: `${listResult[i].LAY_UPLD_DT}`,
            FFL_FILE_NAME: `${listResult[i].FFL_FILE_NAME}`,
            MAP_PRCS_NO: `${listResult[i].MAP_PRCS_NO}`,
            MST_PRCS_STS: `${listResult[i].MST_PRCS_STS}`,
            MAX_RATIO: `${listResult[i].MAX_RATIO}`,
            MST_MSG_ID: `${listResult[i].MST_MSG_ID}`,
            MST_UPD_DT: `${listResult[i].MST_UPD_DT}`,
            MAP_NAME: `${listResult[i].MAP_NAME}`,
            MSG_CNT: `${listResult[i].MSG_CNT}`,
            LAY_PRCS_NO: `${listResult[i].LAY_PRCS_NO}`,
            ROWID: `${listResult[i].ROWID}`
          })
        }
      }
    }
    state.mainGrid = sublistResult;
  }

};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
